<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path stroke="#000" d="M12 19.5a7.5 7.5 0 100-15 7.5 7.5 0 000 15z"/>
  <path fill="#000" d="M10.5 12a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z"/>
  <path stroke="#000" d="M12 2v3m-7 7H2m10 7v3m7-10h3"/>
</svg>
